import React from "react";

interface Props {
  url: string;
}

const UrlCell: React.FC<Props> = ({ url }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const fullUrl =
      url.startsWith("http://") || url.startsWith("https://")
        ? url
        : `https://${url}`;
    window.open(fullUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      onClick={handleClick}
      className="text-primary hover:text-link transition-colors cursor-pointer truncate block text-left"
    >
      {url}
    </button>
  );
};

export default UrlCell;
